import { OtpService } from "@/services";
import vueAwesomeCountdown from "vue-awesome-countdown";

export default {
  name: "otp-order",
  components: {
    vueAwesomeCountdown
  },
  props: {
    otpType: {
      required: true
    }
  },
  data() {
    return {
      needOtp: true,
      isSms: null,
      isCall: null,
      otpChannels: [],
      otpInputModel: {
        otp_type: this.otpType
      },
      counterTime: 0,
      isCounterExpired: false,
      countdownTimer: ""
    };
  },
  computed: {},
  mounted() {
    this.getOtpStatus();
  },
  methods: {
    getOtpStatus() {
      let refNo = this.$route.params.id;
      OtpService.otpChannels(this.otpType, refNo).then(res => {
        this.needOtp = !res.data.data.every(data => !data.active);
        this.otpChannels = res.data.data.map(data => {
          if (data.channel === "sms" && data.active) {
            this.isSms = true;
          }
          if (data.channel === "sms" && !data.active) {
            this.isSms = false;
          }
          if (data.channel === "call" && data.active) {
            this.isCall = true;
          }
          if (data.channel === "call" && !data.active) {
            this.isCall = false;
          }
          return data;
        });
      });
    },
    sendOtpMethod(otpChannel) {
      let data = {
        otp_type: this.otpType,
        otp_channel: otpChannel.channel,
        ref_no: this.$route.params.id
      };
      OtpService.sendOtp(data)
        .then(res => {
          otpChannel.remaining_time = res.data.data.ttl;
          this.$toast.success(res.data.message);
        })
        .catch(err => {
          if (err.status === 422) {
            this.getOtpStatus();
          }
          if (err.status === 409) {
            this.$router.push("/account/security");
          }
        });
    },
    verifyOtp() {
      if (this.otpInputModel.sms) {
        this.otpInputModel["voice_call_or_sms"] = this.otpInputModel.sms;
      }
      this.otpInputModel.ref_no = this.$route.params.id;
      OtpService.verifyOtp(this.otpInputModel)
        .then(() => {
          this.$emit("changeStep");
        })
        .catch(err => {
          if (err.status === 422) {
            this.getOtpStatus();
          }
          if (err.status === 409) {
            this.$router.push("/account/security");
          }
        });
    },
    // countdown(distance) {
    //   distance = distance / 1000;
    //   this.clockInterval = setInterval(() => {
    //     distance--;
    //     let minutes = Math.floor(distance / 60);
    //     let seconds = Math.floor(distance % 60);
    //     if (minutes < 10) {
    //       minutes = "0" + minutes;
    //     }
    //     if (seconds < 10) {
    //       seconds = "0" + seconds;
    //     }
    //     let x = minutes + ":" + seconds;
    //     if (distance < 0) {
    //       this.countdownTimer = "00:00";
    //       this.isCounterExpired = true;
    //       clearInterval(this.clockInterval);
    //     } else {
    //       this.countdownTimer = x;
    //     }
    //   }, 1000);
    // },
    onExpiredTime(otpChannel) {
      otpChannel["remaining_time"] = 0;
    }
  }
};
